import { useState } from 'react';
import PropTypes from 'prop-types';

// material-ui
import { Button, IconButton, Stack, TextField, Tooltip } from '@mui/material';

// project imports
import { useDispatch } from 'store';
import { rateAnswer } from 'store/slices/askJivan';

// assets
import { IconThumbUp, IconThumbDown } from '@tabler/icons';

// Thumbs on one answer. Clicking the active thumb takes the rating back. A thumbs
// down offers an optional note on what was wrong.
const AnswerFeedback = ({ messageId, rating }) => {
    const dispatch = useDispatch();
    const [commentOpen, setCommentOpen] = useState(false);
    const [comment, setComment] = useState('');

    const rate = (clicked) => {
        const nextRating = rating === clicked ? null : clicked;
        dispatch(rateAnswer(messageId, nextRating, null));
        setCommentOpen(nextRating === 'DOWN');
    };

    const sendComment = () => {
        dispatch(rateAnswer(messageId, 'DOWN', comment));
        setCommentOpen(false);
        setComment('');
    };

    return (
        <>
            <Stack direction="row" sx={{ mt: 0.5 }}>
                <Tooltip title="Helpful" placement="top">
                    <IconButton
                        size="small"
                        color={rating === 'UP' ? 'success' : 'default'}
                        onClick={() => rate('UP')}
                        data-testid="ask-jivan-thumb-up"
                        aria-pressed={rating === 'UP'}
                    >
                        <IconThumbUp size={16} />
                    </IconButton>
                </Tooltip>
                <Tooltip title="Not helpful" placement="top">
                    <IconButton
                        size="small"
                        color={rating === 'DOWN' ? 'error' : 'default'}
                        onClick={() => rate('DOWN')}
                        data-testid="ask-jivan-thumb-down"
                        aria-pressed={rating === 'DOWN'}
                    >
                        <IconThumbDown size={16} />
                    </IconButton>
                </Tooltip>
            </Stack>
            {commentOpen && (
                <Stack direction="row" gap={1} sx={{ mt: 0.5 }}>
                    <TextField
                        size="small"
                        fullWidth
                        placeholder="What was wrong? (optional)"
                        value={comment}
                        onChange={(event) => setComment(event.target.value)}
                        inputProps={{ maxLength: 2000, 'data-testid': 'ask-jivan-feedback-comment' }}
                    />
                    <Button size="small" onClick={sendComment} disabled={!comment.trim()}>
                        Send
                    </Button>
                </Stack>
            )}
        </>
    );
};

AnswerFeedback.propTypes = {
    messageId: PropTypes.number.isRequired,
    rating: PropTypes.oneOf(['UP', 'DOWN'])
};

AnswerFeedback.defaultProps = {
    rating: null
};

export default AnswerFeedback;
